// Validador de Acesso Compartilhado
// Detecta parâmetro ?share=UUID e mostra pop-up de senha

document.addEventListener('DOMContentLoaded', async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const shareUuid = urlParams.get('share')
  
  if (!shareUuid) return
  
  // Pegar job_id da URL
  const pathMatch = window.location.pathname.match(/\/ats\/company\/jobs\/(\d+)/)
  if (!pathMatch) return
  
  const jobId = pathMatch[1]
  
  // Verificar se já foi validado nesta sessão
  const cachedAccess = sessionStorage.getItem(`shared_access_${shareUuid}`)
  if (cachedAccess) {
    const { role, job_id } = JSON.parse(cachedAccess)
    // Já validado, apenas injeta role no contexto
    await injectSharedContext(role, shareUuid, job_id)

    if (document.getElementById('shared-access-pending-validation')) {
      location.reload()
    }

    return
  }
  
  // Mostrar pop-up de senha
  showPasswordPopup(shareUuid, jobId)
})

function showPasswordPopup(uuid, jobId) {
  // Criar pop-up modal
  const modalHTML = `
    <div class="modal fade show d-block" id="shared-access-modal" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fas fa-lock me-2"></i>
              Acesso Compartilhado
            </h5>
          </div>
          <div class="modal-body">
            <p class="mb-3">Esta vaga foi compartilhada com você. Digite a senha para acessar:</p>
            <form id="shared-access-form">
              <div class="mb-3">
                <label for="shared-password" class="form-label">Senha</label>
                <div class="input-group input-group-lg">
                  <input type="password"
                         id="shared-password"
                         class="form-control"
                         placeholder="Digite a senha"
                         required
                         autofocus>
                  <button type="button"
                          class="btn btn-outline-secondary"
                          id="toggle-shared-password"
                          aria-label="Mostrar senha">
                    <i class="fas fa-eye"></i>
                  </button>
                </div>
              </div>
              <div id="error-message" class="alert alert-danger d-none"></div>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary btn-lg" id="submit-btn">
                  <i class="fas fa-unlock me-2"></i>
                  Acessar
                </button>
              </div>
            </form>
          </div>
          <div class="modal-footer text-center">
            <small class="text-muted">
              <i class="fas fa-info-circle me-1"></i>
              Se você não tem a senha, solicite ao responsável que compartilhou o link.
            </small>
          </div>
        </div>
      </div>
    </div>
  `
  
  document.body.insertAdjacentHTML('beforeend', modalHTML)
  
  const modal = document.getElementById('shared-access-modal')
  const form = document.getElementById('shared-access-form')
  const passwordInput = document.getElementById('shared-password')
  const submitBtn = document.getElementById('submit-btn')
  const togglePasswordBtn = document.getElementById('toggle-shared-password')
  const togglePasswordIcon = togglePasswordBtn.querySelector('i')
  const errorDiv = document.getElementById('error-message')
  
  // Focus no input
  passwordInput.focus()

  // Toggle visibilidade da senha
  togglePasswordBtn.addEventListener('click', () => {
    const isHidden = passwordInput.type === 'password'
    passwordInput.type = isHidden ? 'text' : 'password'
    togglePasswordIcon.className = isHidden ? 'fas fa-eye-slash' : 'fas fa-eye'
    togglePasswordBtn.setAttribute('aria-label', isHidden ? 'Ocultar senha' : 'Mostrar senha')
  })
  
  // Handler do form
  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    
    const password = passwordInput.value
    
    // Desabilitar form durante request
    submitBtn.disabled = true
    submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i> Validando...'
    passwordInput.disabled = true
    errorDiv.classList.add('d-none')
    
    try {
      const response = await fetch(`/ats/company/jobs/${jobId}/validate_shared_access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ uuid, password })
      })
      
      const data = await response.json()
      
      if (data.success) {
        // Armazenar na sessionStorage
        sessionStorage.setItem(`shared_access_${uuid}`, JSON.stringify({
          role: data.role,
          uuid: data.uuid,
          job_id: data.job_id
        }))
        
        // Feedback visual de sucesso
        submitBtn.innerHTML = '<i class="fas fa-check me-2"></i> Acesso liberado!'
        submitBtn.classList.remove('btn-primary')
        submitBtn.classList.add('btn-success')
        
        // Injetar contexto e recarregar
        await injectSharedContext(data.role, data.uuid, data.job_id)
        
        // Remover modal e recarregar página
        setTimeout(() => {
          modal.remove()
          location.reload()
        }, 1000)
      } else {
        // Mostrar erro
        errorDiv.textContent = data.error
        errorDiv.classList.remove('d-none')
        
        // Reabilitar form
        submitBtn.disabled = false
        submitBtn.innerHTML = '<i class="fas fa-unlock me-2"></i> Acessar'
        passwordInput.disabled = false
        passwordInput.value = ''
        passwordInput.focus()
      }
    } catch (error) {
      console.error('Error validating shared access:', error)
      errorDiv.textContent = 'Erro ao validar acesso. Verifique sua conexão e tente novamente.'
      errorDiv.classList.remove('d-none')
      
      // Reabilitar form
      submitBtn.disabled = false
      submitBtn.innerHTML = '<i class="fas fa-unlock me-2"></i> Acessar'
      passwordInput.disabled = false
      passwordInput.focus()
    }
  })
}

async function injectSharedContext(role, uuid, jobId) {
  // Enviar para Rails session via fetch
  try {
    await fetch('/ats/company/jobs/set_shared_context', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ role, uuid, job_id: jobId })
    })
  } catch (error) {
    console.error('Error setting shared context:', error)
  }
}
